/**
 * v4 "Giới thiệu bạn bè" (server referrals.py): a page opened from a friend's link `/?ref=<code>` keeps the code in
 * this browser for 30 days and sends it with the next sign-in; the server records it only when that sign-in creates
 * the account. The code leaves the address bar at once (nothing to copy along by mistake, no reload loop).
 */

export const REF_KEY = "idphoto.ref.v1";
export const REF_DAYS = 30;
const CODE = /^[A-Za-z0-9]{4,16}$/;

interface Stored {
  code: string;
  until: number;
}

/** `?ref=` of the address → kept for REF_DAYS (an invalid one is dropped too), then removed from the address. */
export function captureRef(now = Date.now()): string | null {
  let code: string | null = null;
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("ref")) return null;
    const value = (url.searchParams.get("ref") ?? "").trim();
    if (CODE.test(value)) {
      code = value.toUpperCase();
      const stored: Stored = { code, until: now + REF_DAYS * 86_400_000 };
      window.localStorage.setItem(REF_KEY, JSON.stringify(stored));
    }
    url.searchParams.delete("ref");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  } catch {
    /* blocked storage or history: the visit works without the referral */
  }
  return code;
}

/** The code to send with the sign-in, or null (none, expired, unreadable). */
export function pendingRef(now = Date.now()): string | null {
  try {
    const raw = window.localStorage.getItem(REF_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<Stored>;
    if (typeof v.code === "string" && CODE.test(v.code) && typeof v.until === "number" && v.until > now) return v.code;
    window.localStorage.removeItem(REF_KEY);
  } catch {
    /* unreadable: as if none */
  }
  return null;
}

/** After a successful sign-in (recorded or not, the code has been used). */
export function clearRef(): void {
  try {
    window.localStorage.removeItem(REF_KEY);
  } catch {
    /* blocked storage */
  }
}

/** The full link to share: this site's origin + the server's path ("/?ref=ABC2345"). */
export function referralUrl(path: string, origin = window.location.origin): string {
  return `${origin}${path}`;
}
